/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Api_TitleInputs */

const en_mk_team_api_title = /** @type {(inputs: Mk_Team_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring your own API key`)
};

const id_mk_team_api_title = /** @type {(inputs: Mk_Team_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa API key sendiri`)
};

/**
* | output |
* | --- |
* | "Bring your own API key" |
*
* @param {Mk_Team_Api_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_api_title = /** @type {((inputs?: Mk_Team_Api_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Api_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_api_title(inputs)
	return en_mk_team_api_title(inputs)
});